var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3926,
    cy: 17.2412,
    rx: 16.5,
    ry: 16.9267,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7256 9.88867C13.5856 9.88867 10.2256 13.3356 10.2256 17.5826C10.2256 21.8297 13.5856 25.2766 17.7256 25.2766C21.8656 25.2766 25.2256 21.8297 25.2256 17.5826C25.2256 13.3356 21.8656 9.88867 17.7256 9.88867ZM17.7256 12.1969C18.9706 12.1969 19.9756 13.2279 19.9756 14.5051C19.9756 15.7823 18.9706 16.8132 17.7256 16.8132C16.4806 16.8132 15.4756 15.7823 15.4756 14.5051C15.4756 13.2279 16.4806 12.1969 17.7256 12.1969ZM17.7256 23.1223C15.8506 23.1223 14.1931 22.1375 13.2256 20.6448C13.2481 19.1137 16.2256 18.2751 17.7256 18.2751C19.2181 18.2751 22.2031 19.1137 22.2256 20.6448C21.2581 22.1375 19.6006 23.1223 17.7256 23.1223Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.7307d2da086d459c8caf67ce22b778d0.svg";
export { ForwardRef as ReactComponent };